// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-main-container {
  background: transparent linear-gradient(24deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
  border-radius: 45px;
  opacity: 1;
  margin-bottom: 1.5% !important;
  margin-left: 10% !important;
  margin-right: 10% !important;
}
.footer-main-container .footer-logo-img {
  width: 80px;
}
.footer-main-container .pamo-location {
  font-size: 13px;
}

.footer-parent-container {
  padding: 0px 10%;
}

@media only screen and (max-width: 992px) {
  .footer-parent-container {
    display: flex !important;
    padding: 0px 10%;
  }
  .footer-logo {
    margin-left: -25% !important;
  }
  .footer-logo-and-location {
    display: flex !important;
    justify-content: center !important;
    flex-direction: column; /* Added to center align logo and location vertically */
    align-items: center;
    margin-left: -13% !important; /* Added to center align logo and location horizontally */
  }
  .pamo-location {
    text-align: start;
    padding-top: 10px;
    margin-left: 45% !important;
    font-size: 12px !important;
    width: 300px !important;
  }
  .footer-socials-icons {
    display: flex !important;
    justify-content: center !important;
    margin-top: 10px;
    background: transparent !important;
  }
  .footer-links {
    display: inline !important;
    justify-content: center !important;
    margin-top: 10px;
  }
  .privacy-link {
    text-align: start;
    margin-top: 10px;
  }
  .ts-and-cs-link {
    text-align: center;
  }
}
@media only screen and (max-width: 767px) {
  .footer-parent-container {
    display: flex !important;
  }
  .footer-logo {
    margin-left: -25% !important;
  }
  .footer-logo-and-location {
    display: flex !important;
    justify-content: center !important;
    flex-direction: column; /* Added to center align logo and location vertically */
    align-items: center;
    margin-left: -13% !important; /* Added to center align logo and location horizontally */
  }
  .pamo-location {
    text-align: start;
    padding-top: 10px;
    margin-left: 45% !important;
    font-size: 12px !important;
    width: 300px !important;
  }
  .footer-socials-icons {
    display: flex !important;
    justify-content: center !important;
    margin-top: 10px;
    background: transparent !important;
  }
  .footer-links {
    display: inline !important;
    justify-content: center !important;
    margin-top: 10px;
  }
  .privacy-link {
    text-align: start;
    margin-top: 10px;
    font-size: 14px !important;
  }
  .ts-and-cs-link {
    text-align: center;
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 620px) {
  .footer-main-container {
    margin: 0% !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    width: 100vw !important;
    padding: 0px !important;
    left: 0px !important;
  }
  .footer-parent-container {
    display: inline !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .privacy-link {
    justify-content: center !important;
    text-align: center;
  }
  .footer-logo-and-location {
    text-align: center !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .pamo-location {
    text-align: center !important;
    justify-content: center !important;
    align-items: center !important;
    margin: 0px !important;
    padding: 0% !important;
    padding-left: 15% !important;
  }
  .footer-logo {
    margin-left: 0px !important;
    padding-left: 15% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/common/footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,oGAAA;EAEA,mBAAA;EACA,UAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;AAAF;AAGE;EACE,WAAA;AADJ;AAIE;EACE,eAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE;IACE,wBAAA;IACA,gBAAA;EAHF;EAOA;IACE,4BAAA;EALF;EAQA;IACE,wBAAA;IACA,kCAAA;IACA,sBAAA,EAAA,uDAAA;IACA,mBAAA;IACA,4BAAA,EAAA,yDAAA;EANF;EASA;IACE,iBAAA;IACA,iBAAA;IACA,2BAAA;IACA,0BAAA;IACA,uBAAA;EAPF;EAUA;IACE,wBAAA;IACA,kCAAA;IACA,gBAAA;IACA,kCAAA;EARF;EAYA;IACE,0BAAA;IACA,kCAAA;IACA,gBAAA;EAVF;EAYA;IACE,iBAAA;IACA,gBAAA;EAVF;EAaA;IACE,kBAAA;EAXF;AACF;AAcA;EACE;IACE,wBAAA;EAZF;EAgBA;IACE,4BAAA;EAdF;EAiBA;IACE,wBAAA;IACA,kCAAA;IACA,sBAAA,EAAA,uDAAA;IACA,mBAAA;IACA,4BAAA,EAAA,yDAAA;EAfF;EAkBA;IACE,iBAAA;IACA,iBAAA;IACA,2BAAA;IACA,0BAAA;IACA,uBAAA;EAhBF;EAmBA;IACE,wBAAA;IACA,kCAAA;IACA,gBAAA;IACA,kCAAA;EAjBF;EAqBA;IACE,0BAAA;IACA,kCAAA;IACA,gBAAA;EAnBF;EAqBA;IACE,iBAAA;IACA,gBAAA;IACA,0BAAA;EAnBF;EAsBA;IACE,kBAAA;IACA,0BAAA;EApBF;AACF;AAuBA;EACE;IACE,qBAAA;IACA,yCAAA;IACA,0CAAA;IACA,uBAAA;IACA,uBAAA;IACA,oBAAA;EArBF;EAwBA;IACE,0BAAA;IACA,kCAAA;IACA,8BAAA;EAtBF;EA0BE;IACE,kCAAA;IACA,kBAAA;EAxBJ;EA6BA;IACD,6BAAA;IACA,kCAAA;IACA,8BAAA;EA3BC;EA+BE;IACE,6BAAA;IACA,kCAAA;IACA,8BAAA;IACA,sBAAA;IACA,sBAAA;IACA,4BAAA;EA7BJ;EAiCE;IAEJ,2BAAA;IACA,4BAAA;EAhCE;AACF","sourcesContent":[".footer-main-container {\n  background: transparent linear-gradient(24deg, #7062f9 0%, #8d81fa 100%) 0% 0%\n    no-repeat padding-box;\n  border-radius: 45px;\n  opacity: 1;\n  margin-bottom: 1.5% !important;\n  margin-left: 10% !important;\n  margin-right: 10% !important;\n  // width:100%;\n\n  .footer-logo-img {\n    width: 80px;\n  }\n\n  .pamo-location {\n    font-size: 13px;\n  }\n}\n\n.footer-parent-container {\n  padding: 0px 10%;\n}\n\n@media only screen and (max-width: 992px) {\n  .footer-parent-container {\n    display: flex !important;\n    padding: 0px 10%;\n    // justify-content: stretch !important;\n  }\n\n  .footer-logo {\n    margin-left: -25% !important;\n  }\n\n  .footer-logo-and-location {\n    display: flex !important;\n    justify-content: center !important;\n    flex-direction: column; /* Added to center align logo and location vertically */\n    align-items: center;\n    margin-left: -13% !important; /* Added to center align logo and location horizontally */\n  }\n\n  .pamo-location {\n    text-align: start;\n    padding-top: 10px;\n    margin-left: 45% !important;\n    font-size: 12px !important;\n    width: 300px !important;\n  }\n\n  .footer-socials-icons {\n    display: flex !important;\n    justify-content: center !important;\n    margin-top: 10px;\n    background: transparent !important;\n    // margin-left:35%;\n  }\n\n  .footer-links {\n    display: inline !important;\n    justify-content: center !important;\n    margin-top: 10px;\n  }\n  .privacy-link {\n    text-align: start;\n    margin-top: 10px;\n  }\n\n  .ts-and-cs-link {\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .footer-parent-container {\n    display: flex !important;\n    // justify-content: stretch !important;\n  }\n\n  .footer-logo {\n    margin-left: -25% !important;\n  }\n\n  .footer-logo-and-location {\n    display: flex !important;\n    justify-content: center !important;\n    flex-direction: column; /* Added to center align logo and location vertically */\n    align-items: center;\n    margin-left: -13% !important; /* Added to center align logo and location horizontally */\n  }\n\n  .pamo-location {\n    text-align: start;\n    padding-top: 10px;\n    margin-left: 45% !important;\n    font-size: 12px !important;\n    width: 300px !important;\n  }\n\n  .footer-socials-icons {\n    display: flex !important;\n    justify-content: center !important;\n    margin-top: 10px;\n    background: transparent !important;\n    // margin-left:35%;\n  }\n\n  .footer-links {\n    display: inline !important;\n    justify-content: center !important;\n    margin-top: 10px;\n  }\n  .privacy-link {\n    text-align: start;\n    margin-top: 10px;\n    font-size: 14px !important;\n  }\n\n  .ts-and-cs-link {\n    text-align: center;\n    font-size: 14px !important;\n  }\n}\n\n@media only screen and (max-width: 620px) {\n  .footer-main-container {\n    margin:0% !important;\n    border-bottom-left-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n    width:100vw !important;\n    padding:0px !important;\n    left:0px !important;\n  }\n\n  .footer-parent-container{\n    display:inline !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n\n\n    .privacy-link {\n      justify-content: center !important;\n      text-align: center;\n    }\n\n  \n\n  .footer-logo-and-location{\n text-align:center !important;\n justify-content: center !important;\n align-items: center !important;\n \n  }\n   \n    .pamo-location{\n      text-align: center !important;\n      justify-content: center !important;\n      align-items: center !important;\n      margin: 0px !important;\n      padding: 0% !important;\n      padding-left: 15% !important;\n     \n    }\n\n    .footer-logo {\n\nmargin-left: 0px !important;\npadding-left: 15% !important;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
